import React from 'react'

import PropTypes from 'prop-types'
import {useStyleConfig, IconButton, Badge} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'

import {CartIcon} from '../icons'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {useIntl} from 'react-intl'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import {useBasketTotalItems} from '../../hooks/use-basket-total-items'

const HeaderCartButton = ({onMyCartClick = noop}) => {
    const styles = useStyleConfig('MiniCartPopover', {})
    const iconStyles = useStyleConfig('Header', {})

    const intl = useIntl()
    const {data: basket} = useCurrentBasket()
    const totalItems = useBasketTotalItems()

    return (
        <IconButton
            aria-label={intl.formatMessage(
                {
                    id: 'header.button.assistive_msg.my_cart_with_num_items',
                    defaultMessage: 'My cart, number of items: {numItems}',
                },
                {numItems: totalItems || 0},
            )}
            icon={
                <>
                    <CartIcon sx={iconStyles.headerIcon} />
                    {basket && totalItems > 0 && (
                        <Badge
                            data-testid="cart-item-count"
                            variant="notification"
                            {...styles.badge}
                            sx={{
                                width: remCalc(14),
                                minWidth: remCalc(14),
                                maxWidth: remCalc(14),
                                padding: 0,
                                boxSizing: 'border-box',
                            }}
                        >
                            {totalItems}
                        </Badge>
                    )}
                </>
            }
            data-testid="cart-icon"
            variant="ghost"
            onClick={onMyCartClick}
            {...iconStyles.buttonIcons}
        />
    )
}

HeaderCartButton.propTypes = {
    onMyCartClick: PropTypes.func,
}

export default HeaderCartButton
